import { type Enum } from '@webapp/infrastructure/types/Enum'

// Object-permission codenames used with /api/v3/permissions/objects/* endpoints.
// view_report on a SecondaryCategory (Department content type) grants the user
// visibility of that SecondaryCategory's data in spending reports.
export const ObjectPermissions = {
  VIEW_REPORT: 'view_report', // Report visibility grant per SecondaryCategory
} as const

export type ObjectPermissionEnum = Enum<typeof ObjectPermissions>
